export default "__VITE_ASSET__406cd679__"